import * as stellarSDK from '@stellar/stellar-sdk';

export function isStellarAccount(accountId:string):boolean{

    const result = stellarSDK.StrKey.isValidEd25519PublicKey(accountId);
    return result;
}

export function shortenAccountId (fullStr:string,length?:number){

    let strLen = 18;

    if (length){
        strLen=length
    }
    const separator = '...';

    if (fullStr.length <= strLen) return fullStr;

        const sepLen = separator.length;
        const charsToShow = strLen - sepLen;
        const frontChars = Math.ceil(charsToShow/2);
        const backChars = Math.floor(charsToShow/2);

    return fullStr.substr(0, frontChars) + 
        separator + 
        fullStr.substr(fullStr.length - backChars);
}

export function convertXDRToJSON (xdr:string){

    try {

        return JSON.stringify(stellarSDK.xdr.TransactionEnvelope.fromXDR(xdr, 'base64'));
        
    } catch (error) {

        return null
        
    }
}

export function createStellarKeys(){

    const pair = stellarSDK.Keypair.random();

    return [pair.publicKey(),pair.secret()]
}
